import { ServiceConfig } from "../types/serviceTypes";

export const heRecognitionServiceMAConfig: ServiceConfig = {
  baseHref: "/my-applications",
  external: false,
  titleCode: "t.page.higherEduRecognition",
  descriptionCode: null,
};
export const seRecognitionServiceMAConfig: ServiceConfig = {
  baseHref: "/my-applications",
  external: false,
  titleCode: "t.page.secondaryEduRecognition",
  descriptionCode: null,
};

export const seVerificationLetterServiceMAConfig: ServiceConfig = {
  baseHref: "/my-applications",
  external: false,
  titleCode: "t.page.secondaryEduVerificationLetter",
  descriptionCode: null,
};

export const seOfficialNoteServiceMAConfig: ServiceConfig = {
  baseHref: "/my-applications",
  external: false,
  titleCode: "t.page.secondaryEduOfficialNote",
  descriptionCode: null,
};

export const uniChecksServiceMAConfig: ServiceConfig = {
  baseHref: "/my-applications",
  external: false,
  titleCode: "t.page.uniChecks",
  descriptionCode: null,
};

export const docDegreesServiceMAConfig: ServiceConfig = {
  baseHref: "/my-applications",
  external: false,
  titleCode: "t.page.doctorateDegrees",
  descriptionCode: null,
};

export const libservAdditionalDocServiceMAConfig: ServiceConfig = {
  baseHref: "/my-applications",
  external: false,
  titleCode: "t.page.libservAdditionalDoc",
  descriptionCode: null,
};

export const rudiAdditionalDocServiceMAConfig: ServiceConfig = {
  baseHref: "/my-applications",
  external: false,
  titleCode: "t.page.rudiAdditionalDoc",
  descriptionCode: null,
};

export const regprofAdditionalDocServiceMAConfig: ServiceConfig = {
  baseHref: "/my-applications",
  external: false,
  titleCode: "t.page.regprofAdditionalDoc",
  descriptionCode: null,
};

export const seAdditionalDocServiceMAConfig: ServiceConfig = {
  baseHref: "/my-applications",
  external: false,
  titleCode: "t.page.seAdditionalDoc",
  descriptionCode: null,
};

export const regprofServiceMAConfig: ServiceConfig = {
  baseHref: "/my-applications",
  external: false,
  titleCode: "t.page.regprof",
  descriptionCode: null,
};

export const officialNotesServiceMAConfig: ServiceConfig = {
  baseHref: "/my-applications",
  external: false,
  titleCode: "t.page.officialNotes",
  descriptionCode: null,
};

export const inquiryServiceMAConfig: ServiceConfig = {
  baseHref: "/my-applications",
  external: false,
  titleCode: "t.page.inquiry",
  descriptionCode: null,
};

export const biblioReferenceServiceMAConfig: ServiceConfig = {
  baseHref: "/my-applications",
  external: false,
  titleCode: "t.page.biblioReference",
  descriptionCode: null,
};

export const docDeliveryServiceMAConfig: ServiceConfig = {
  baseHref: "/my-applications",
  external: false,
  titleCode: "t.page.docDelivery",
  descriptionCode: null,
};

export const signalServiceMAConfig: ServiceConfig = {
  baseHref: "/my-applications",
  external: false,
  titleCode: "t.page.signal",
  descriptionCode: null,
};

export const suggestionServiceMAConfig: ServiceConfig = {
  baseHref: "/my-applications",
  external: false,
  titleCode: "t.page.suggestion",
  descriptionCode: null,
};

export const publicAccessServiceMAConfig: ServiceConfig = {
  baseHref: "/my-applications",
  external: false,
  titleCode: "t.page.publicAccess",
  descriptionCode: null,
};
